import { Empty } from "antd";
import SelectAllCard from "../selectAll";
import StopChequeCard from "../stopChequebook";
import { useTranslation } from "react-i18next";

export default function StopchequeGrid({
  dataSource = [],
  handleSelectAll,
  handleMultiApproveOrReject,
  selectAllChecked,
  handleMultiDelete,
  handleCheckBoxChange,
  handleApproveOrReject,
  handleDelete,
}) {
  const { t } = useTranslation();
  return (
    <>
      {dataSource.length === 0 ? (
        <Empty
          description={t("common.no_records_found", {
            defaultValue: "No Records Found",
          })}
        />
      ) : (
        <div className="ft-table">
          <table className="table" style={{ cursor: "pointer" }}>
            <thead style={{ backgroundColor: "#F1F1F1" }}>
              <tr>
                <th>
                  <SelectAllCard
                    record={dataSource}
                    handleSelectAll={handleSelectAll}
                    handleMultiApproveOrReject={handleMultiApproveOrReject}
                    selectAllChecked={selectAllChecked}
                    handleMultiDelete={handleMultiDelete}
                  />
                </th>
                <th>
                  {t("pages.gepeg.source_account", {
                    defaultValue: "Source Account",
                  })}
                </th>
                <th>
                  {t("pages.pending_approval.stop_cheque_number", {
                    defaultValue: "Stop Cheque Number",
                  })}
                </th>
                <th>
                  {t("pages.card_settings.reason", {
                    defaultValue: "Reason",
                  })}
                </th>
                <th>
                  {t("pages.pending_approval.Initiated_Date", {
                    defaultValue: "Initiated Date",
                  })}
                </th>
              </tr>
            </thead>

            <tbody>
              {dataSource.map((option, index) => (
                <StopChequeCard
                  record={option}
                  handleCheckBoxChange={handleCheckBoxChange}
                  handleApproveOrReject={handleApproveOrReject}
                  handleDelete={handleDelete}
                />
              ))}
            </tbody>
          </table>
        </div>
      )}
    </>
  );
}
